import { useEffect, useState } from 'react';
import { useAppSelector } from 'store';
import { useGetOnboardingProgressStatusQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';

export enum OnboardingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  NOT_STARTED = 'NOT_STARTED',
}

export const useUserOnboardingStatus = () => {
  const { currentStore } = useAppSelector(userDetailsState);

  const storageKey = `${currentStore.completeInfo?.store_name?.replaceAll(
    ' ',
    ''
  )}_segments_onboarding_completed`;

  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(
    () => localStorage.getItem(storageKey) === 'true'
  );

  const { data } = useGetOnboardingProgressStatusQuery(
    { serializedStoreName: currentStore.serializedStoreName },
    {
      skip: !!!currentStore.serializedStoreName,
      pollingInterval: hasCompletedOnboarding ? 0 : 6000,
    }
  );

  useEffect(() => {
    if (!data) return;
    if (data.percentage === 100) {
      setHasCompletedOnboarding(true);
      localStorage.setItem(storageKey, 'true');
    } else {
      setHasCompletedOnboarding(false);
      localStorage.setItem(storageKey, 'false');
    }
  }, [data, storageKey]);

  return {
    status: hasCompletedOnboarding
      ? OnboardingStatus.COMPLETED
      : OnboardingStatus.IN_PROGRESS,
    percentage: hasCompletedOnboarding ? 100 : data?.percentage ?? 0,
  };
};
